import type { LocalizedDict } from '../index'

// Work-order screen labels not covered by i18n/supply/work-orders.ts (that
// dictionary is shared with other supply screens).

export type WorkOrderExtraStrings = {
  productionPhotos: string
  productionFiles: string
  workOrderDetail: string
}

export const workOrderExtraI18n: LocalizedDict<WorkOrderExtraStrings> = {
  en: {
    productionPhotos: 'Production Photos',
    productionFiles: 'Production Files',
    workOrderDetail: 'Work order detail',
  },
  tr: {
    productionPhotos: 'Üretim fotoğrafları',
    productionFiles: 'Üretim dosyaları',
    workOrderDetail: 'İş emri detayı',
  },
}
